"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllCallDispositions = exports.CONNECTED = exports.LEFT_VOICEMAIL = exports.LEFT_LIVE_MESSAGE = exports.WRONG_NUMBER = exports.BUSY = exports.NO_ANSWER = void 0;

var _immutable = require("immutable");

var _once = _interopRequireDefault(require("transmute/once"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var NO_ANSWER = '73a0d17f-1163-4015-bdd5-ec830791da20';
exports.NO_ANSWER = NO_ANSWER;
var BUSY = '9d9162e7-6cf3-4944-bf63-4dff82258764';
exports.BUSY = BUSY;
var WRONG_NUMBER = '17b47fee-58de-441e-a44c-c6300d46f273';
exports.WRONG_NUMBER = WRONG_NUMBER;
var LEFT_LIVE_MESSAGE = 'a4c4c377-d246-4b32-a13b-75a56a4cd0ff';
exports.LEFT_LIVE_MESSAGE = LEFT_LIVE_MESSAGE;
var LEFT_VOICEMAIL = 'b2cf5968-551e-4856-9783-52b3da59a7d0';
exports.LEFT_VOICEMAIL = LEFT_VOICEMAIL;
var CONNECTED = 'f240bbac-87c9-4f6e-bf70-924b57d47db7';
exports.CONNECTED = CONNECTED;
var getAllCallDispositions = (0, _once.default)(function () {
  return (0, _immutable.Map)({
    NO_ANSWER: NO_ANSWER,
    BUSY: BUSY,
    WRONG_NUMBER: WRONG_NUMBER,
    LEFT_LIVE_MESSAGE: LEFT_LIVE_MESSAGE,
    LEFT_VOICEMAIL: LEFT_VOICEMAIL,
    CONNECTED: CONNECTED
  }).reduce(function (acc, value, key) {
    return acc.set(value, (0, _propertyTranslator.propertyLabelTranslator)(key.toLowerCase()));
  }, (0, _immutable.OrderedMap)());
});
exports.getAllCallDispositions = getAllCallDispositions;